import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Box, MenuItem } from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  time: null | string;
  setTime: (time: null | string) => void;
}

const NewInfo = (props: Props) => {
  const { register } = props;

  const [damageEtc, setDamageEtc] = useState(0);

  const contents = [
    {
      label: 'Đường dẫn khí',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.symptom')}
          >
            <MenuItem value="patent">Thông thoáng</MenuItem>
            <MenuItem value="compromised">Tổn hại</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: 'Hô hấp',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.etc_symptom')}
          >
            <MenuItem value="no">Không có vấn đề về hô hấp</MenuItem>
            <MenuItem value="mild">Hô hấp khó khăn một chút</MenuItem>
            <MenuItem value="moderate">Hô hấp khó khăn</MenuItem>
            <MenuItem value="severe">Hô hấp vô cùng khó khăn</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: 'Tiếng thở',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.damage')}
            onChange={e => {
              if (e.target.value === 'other') setDamageEtc(1);
              else setDamageEtc(0);
            }}
          >
            <MenuItem value="clear">Đều và rõ ràng</MenuItem>
            <MenuItem value="crackles">Khó thở</MenuItem>
            <MenuItem value="wheezes">Khò khè</MenuItem>
            <MenuItem value="other">Khác</MenuItem>
          </Form.MuiTextField>
          {damageEtc ? (
            <Form.MuiTextField
              {...register('emergency_patient_information.ktas')}
              placeholder="Nhập"
              sx={{ marginLeft: '5px' }}
            />
          ) : null}
        </Box>
      ),
    },
    {
      label: 'Lưu thông',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.intentional')}
        />
      ),
    },
    {
      label: 'Cung cấp nước',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.medical_conditions')}
          >
            <MenuItem value="well">Đủ nước</MenuItem>
            <MenuItem value="mild">Mất nước nhẹ</MenuItem>
            <MenuItem value="moderate">Mất nước nặng</MenuItem>
            <MenuItem value="severe">Mất nước nghiêm trọng</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: 'Da',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.motor')}
        />
      ),
    },
    {
      label: 'Thần kinh',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.consciousness')}
        />
      ),
    },
    {
      label: 'GCS',
      element: (
        <Form.MuiTextField {...register('emergency_patient_information.gcs')} />
      ),
    },

    {
      label: 'Đồng tử',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.pupil')}
        />
      ),
    },
    {
      label: 'Cơn đau',
      element: (
        <Form.MuiTextField {...register('emergency_patient_information.nrs')} />
      ),
    },

    {
      label: 'Dị ứng',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.allergy')}
        />
      ),
    },

    {
      label: 'Phân loại',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.history')}
        />
      ),
    },
  ];

  return (
    <>
      <SectionTitle title="Đánh giá" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => (
          <>
            <RowContent title={label} titleRatio={1} childrenRatio={2}>
              {element}
            </RowContent>
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default NewInfo;
